/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
    object, string, arrayOf, shape, func,
} from 'prop-types';
import { withRouter } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setCountry } from '../../../../state/ducks/App/App-Actions';

const TrendingProducts = ({
    classes, trendingTitle, productLists, disclaimerText, actionSetCountry,
}) => (
    <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.trendingProducts}>
            <h2 className={classes.trendingProductHeading}>{trendingTitle}</h2>
            <ul>
                {productLists.map((list, i)  => (
                    <li className={classes.trendingList} key={['_', i].join('')}>
                        <a className={classes.trendingProductLink} href={list.url} onClick={() => actionSetCountry(list.image_title.toLowerCase())}>
                            <img className={classes.trendingProductImage} src={`https://cdn1.1800flowers.com/wcsstore/Flowers/images/catalog${list.image_url}?height=256&width=234`} alt={list.image_title} />
                            <div className={classes.trendingProductTitle}>{list.image_title}</div>
                            <div className={classes.trendingProductFlag}> <img src={`https://cdn1.1800flowers.com/wcsstore/Flowers/images/banners/international/flags${list.country_flag}?height=33&width=45`} alt={list.image_title} /></div>
                        </a>
                    </li>
                ))}
            </ul>
            <div className={classes.disclaimerText}> { ReactHtmlParser(disclaimerText) }</div>
        </Grid>
    </Grid>
);

TrendingProducts.propTypes = {
    classes: object.isRequired,
    trendingTitle: string.isRequired,
    disclaimerText: string.isRequired,
    productLists: arrayOf(
        shape({
            image_title: string.isRequired,
            country_flag: string.isRequired,
            image_url: string.isRequired,

        }),
    ).isRequired,
    actionSetCountry: func.isRequired,
};
const mapDispatchToProps = (dispatch) => ({
    actionSetCountry: bindActionCreators(setCountry, dispatch),
});
export default withRouter(connect(null, mapDispatchToProps)(TrendingProducts));
